var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.7,
    height: 16.5,
    viewBox: "0 0 11.7 16.5",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b31717",
    stroke: "#b31717",
    strokeWidth: "0.5px",
    d: "M2.827 8.056a.8.8 0 1 1 .586 1.488A2.863 2.863 0 0 0 1.6 12.208V13.6a.8.8 0 0 0 .8.8h6.4a.8.8 0 0 0 .8-.8v-1.318a2.927 2.927 0 0 0-1.885-2.735.8.8 0 1 1 .57-1.494 4.526 4.526 0 0 1 2.915 4.23V13.6A2.4 2.4 0 0 1 8.8 16H2.4A2.4 2.4 0 0 1 0 13.6v-1.392a4.463 4.463 0 0 1 2.827-4.152zM5.6 0a3.2 3.2 0 0 1 3.2 3.2v1.6a3.2 3.2 0 1 1-6.4 0V3.2A3.2 3.2 0 0 1 5.6 0zm0 1.6A1.6 1.6 0 0 0 4 3.2v1.6a1.6 1.6 0 1 0 3.2 0V3.2a1.6 1.6 0 0 0-1.6-1.6z",
    transform: "translate(.25 .25)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user.d3065c632c57cf1321be816c01c2eee2.svg";